import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { BetPerHour } from '../../../Bets/bets';
import { JackPot } from '../../../Bets/jackpot';
import { OtherWinners } from '../../../Bets/others';
import { AverageBet } from '../../../Bets/others copy';
import { BetsPerDay } from '../../../Bets/betsperday';
import CSV from '../../../CSV';
import { BetType } from '../../../Finance/winloss copy';
import { DailyBetsChannel } from '../../../Bets/dailybets';
import { DailyBetsCount } from '../../../Bets/totalbets';
import { BetsType } from '../../../Bets/betstype';
import { JackPotCountMonthly } from '../../../Reports/jackpotcountmonthly';

export default () => (
  <Switch>
    <Route path="/dailybets" component={DailyBetsChannel} />
    <Route path="/dailybetscount" component={DailyBetsCount} />
    <Route path="/reconciledeposits" component={CSV} />
    <Route path="/betsperday" component={BetsPerDay} />
    <Route path="/betsperhour" component={BetPerHour} />
    <Route path="/jackpot" component={JackPot} />
    <Route path="/otherwinners" component={OtherWinners} />
    <Route path="/averagebets" component={AverageBet} />
    <Route path="/jackpotcount" component={JackPotCountMonthly} />
    <Route path="/betstype" component={BetsType} />

    {/* <Route/> */}
  </Switch>
);
